// @ts-nocheck


import { fetchRequest } from './index';

import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

export const convertDataToServer = (
passCalculation) => (
{
  ...passCalculation,
  sum: convertFromRubToKop(passCalculation.sum),
  months: passCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
passCalculation) => (
{
  ...passCalculation,
  sum: convertFromKopToRub(passCalculation.sum),
  months: passCalculation.months.map(convertDataFromServerMonth)
});

export const convertDataToServerMonth = (
passCalculationMonth) => (
{
  ...passCalculationMonth,
  excessRate: convertFromRubToKop(passCalculationMonth.excessRate),
  cost: convertFromRubToKop(passCalculationMonth.cost),
  rate: convertFromRubToKop(passCalculationMonth.rate)
});

export const convertDataFromServerMonth = (
passCalculationMonth) => (
{
  ...passCalculationMonth,
  excessRate: convertFromKopToRub(passCalculationMonth.excessRate),
  cost: convertFromKopToRub(passCalculationMonth.cost),
  rate: convertFromKopToRub(passCalculationMonth.rate)
});

const basedUrl = 'passCalculation';
const passCalculation = new CommonApi(
  basedUrl,
  'расчет потребности в пропусках',
  convertDataToServer,
  convertDataFromServer
);

export const updateCalculations = async (
data) =>
{
  const updated = await fetchRequest.put(
    `/${basedUrl}/updateCalculations`,
    data
  );
  if (updated) return updated;
  throw new Error(`Не удалось отредактировать`);
};

export default {
  ...passCalculation,
  updateCalculations
};
